import React from 'react';
import { FastField as FormikField } from 'formik';
import { Content as RightRailContent } from '../../gs-component-right-rail';
import { FormRow, FormColumn } from '@xo-union/tk-component-form-grid';
import { Field as UnionField } from '../../gs-component-form';
import styles from './styles.scss';
import { Household, FocusOn } from '../interfaces';
import FormattedPhoneNumber from '../ContactInfo/FormattedPhoneNumber';

interface HouseholdsProps {
  focusOn: FocusOn;
  householdsList: Household[];
}

const Households: React.FC<HouseholdsProps> = ({ householdsList, focusOn }) => {
  const fieldName = focusOn === 'phone' ? 'phone numbers' : 'email addresses';

  return (
    <RightRailContent className={styles.content}>
      <div className={styles.householdRow}>Please add {fieldName} for the following guests.</div>
      {householdsList.map((household, householdIndex) => {
        const leader = household.people.find(p => p.isLeader === true);
        const leaderIndex = household.people.findIndex(({ isLeader }) => isLeader);
        const householdSize = household.people.length ?? 0;
        return leader ? (
          <div className={styles.householdRow} key={household.id}>
            <div className={styles.householdInfo}>
              <div className={styles.leaderName}>
                <span>{`${leader.firstName} ${leader.lastName}`.trim()}</span>
                <span>{householdSize > 1 ? ` + ${householdSize - 1} guest${householdSize > 2 ? 's' : ''}` : ''}</span>
              </div>
              <FormRow>
                <FormColumn md>
                  {focusOn === 'phone' ? (
                    <FormikField
                      name={`${householdIndex}.people.${leaderIndex}.phone`}
                      data-testid="phone"
                      label="Phone Number"
                      component={FormattedPhoneNumber}
                      type="tel"
                    />
                  ) : (
                    <FormikField
                      name={`${householdIndex}.people.${leaderIndex}.email`}
                      data-testid="email"
                      label="Email Address"
                      component={UnionField}
                      type="email"
                    />
                  )}
                </FormColumn>
              </FormRow>
            </div>
          </div>
        ) : null;
      })}
    </RightRailContent>
  );
};

export default Households;
